<template>
  <div id="user_healths_sign_outer">
    <div style="font-weight: bold;font-size: 1.3rem;text-align: center;align-self: center;">
      签署防疫承诺书<br>
      <span style="font-size: 1rem">(2/3)</span>
    </div>

    <div class="read-only-text">{{topText}}</div>

    <div class="user-base-infors" style="align-self: flex-start;" v-if="order && order != null">
      <div style="font-weight: bold;">基本信息</div>
      <div>
        <span style="font-weight: bold;">姓名:</span> &nbsp;{{ order.trainingEnrollDetail.name}}
      </div>
      <div>
        <span style="font-weight: bold;">性别:</span> &nbsp;{{order.trainingEnrollDetail.sex == 1 ? '男' : '女'}}
      </div>

      <div>
        <span style="font-weight: bold;">身份证号:</span> &nbsp;{{order.trainingEnrollDetail.idNo}}
      </div>

      <div>
        <span style="font-weight: bold;">联系方式:</span> &nbsp;{{order.trainingEnrollDetail.mobile}}
      </div>
    </div>

    <div style="margin-top: 30px;align-self: flex-start;">
      <div style="font-weight: bold;">有无发热或呼吸道症状</div>


     <div style="margin-top: 10px;">
       <el-radio v-model="checkValue" label="0" >否</el-radio>
       <el-radio v-model="checkValue" label="1" >是</el-radio>
     </div>

      <div style="font-weight: bold;margin-top: 10px;">健康状况</div>

      <el-select style="margin-top: 10px;" placeholder="请选择您当前的健康状况"  v-model="healths">
        <el-option v-for="(item, index) in healthSelects" :key="'health_check_' + index" :label="item" :value="item"></el-option>
      </el-select>
    </div>

    <div class="read-only-text" style="margin-top: 30px;">{{bottomText}}</div>

    <div style="align-self: center;margin-top: 30px;display: flex;flex-direction: column;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
      <el-button style="min-width: 150px;background-color: #3E55FA;color: white;" @click="signatureButtonClicked" >{{signature != '' ? '重新签名' : '签名'}}</el-button>
      <img v-if="signature != ''" :src="signature" style="margin-top: 10px;max-width: 100%;height: auto;max-height: 120px;border: solid 1px #eee;">
    </div>

    <div style="align-self: center;font-size: 0.8rem;margin-top: 5px;">*16周岁以下人员由法定监护人代签</div>
    <el-button round
               @click="submitUserHealthData"
               style="color: white;background-color: #fc1a34;border: none;width: 150px;margin-top: 20px;align-self: center;">下一步</el-button>


    <my-signature v-if="showSignatureVue"
                  @success="signatureSuccess"
                  @close="showSignatureVue = false" ></my-signature>
  </div>
</template>

<script>
  import MySignature from "../common/MySignature";
export default {
  name: "UserHealthSignProtocols",
  components: {
    MySignature
  },
  props:{
    order: Object
  },
  data() {
    return {
      topText: '为安全有序的恢复上海市篮球协会培训课程，' +
        '切实保障全体参与培训人员的身体健康，' +
        '根据本市疾控部门的有关要求，' +
        '请如实逐项填报登记表。' +
        '如故意隐瞒或虚假填报个人信息，' +
        '可能会收到法律追究。',

      bottomText: '本人承诺：已阅读承诺书所有事项，' +
        '并保证提供的信息真实准确。' +
        '遵守上海市篮球协会有关疫情防疫工作要求和规则；' +
        '参与培训课程前14天内，未前往中、高风险地区，如出现发热、连续咳嗽、呕吐等疑似现象或接触过中、高风险地区人员的，' +
        '则主动前往医疗机构就医或进行核酸检测，' +
        '确保本人健康参与培训课程。',

      healthSelects: [
        '发热',
        '咳嗽',
        '流涕',
        '咽痛',
        '咳痰',
        '胸痛',
        '畏寒',
        '腹泻',
        '无上述异常症状',
      ],
      healths: '',
      userData: null,
      checkValue: '',
      signature: '',
      showSignatureVue: false,
    }
  },
  computed: {

  },
  mounted() {
    this.userData = {
      name: '厉进虎',
      gender: 1,
      id: '32085390348395',
      mobile: '17301781425',
    }
  },
  methods: {
    signatureButtonClicked() {
      this.showSignatureVue = true;
    },
    signatureSuccess(result) {
      let signatureUrl = result.signatureUrl;
      this.signature = signatureUrl;
      this.showSignatureVue = false;
    },
    submitUserHealthData() {

      let params = this.order;
      if (params == undefined || params == null) {
        return;
      }

      let checkValue = this.checkValue;
      if (checkValue == '') {
        this.$toast('您尚未选择您是否发热或呼吸道症状！');
        return;
      }

      params.trainingEnrollDetail.fever = checkValue;

      let healths = this.healths;
      if (healths == '') {
        this.$toast('您尚未选择您的健康状况！');
        return;
      }
      params.trainingEnrollDetail.health = healths;

      let signature = this.signature;
      if (signature == '') {
        this.$toast('您尚未签名！');
        return;
      }

      params.trainingEnrollDetail.visa = signature;
      params.step = 2;
      this.$emit('next-step-clicked', params);
    },
  }

}
</script>

<style scoped>

  #user_healths_sign_outer {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
  }

  @media screen and (min-width: 768px){
    #user_healths_sign_outer {
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: nowrap;
    }
  }

  #user_healths_sign_outer .read-only-text {
    font-size: 1rem;
    color: #333;
    text-align: left;
  }

  #user_healths_sign_outer .user-base-infors {
    margin-top: 30px;
  }

  #user_healths_sign_outer .user-base-infors > div:not(:first-child) {
    margin-top: 5px;
  }

  #user_healths_sign_outer  /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #user_healths_sign_outer  /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
    border-color: #fc1a34;
    background-color: #fc1a34;
  }
  #user_healths_sign_outer  /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }

  #user_healths_sign_outer /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

</style>



// WEBPACK FOOTER //
// src/components/course/UserHealthSignProtocols.vue